import React from 'react';
import { BookOpen, ExternalLink, FileText, Layers, ListChecks } from 'lucide-react';
import type { OpportunityPreparationLink } from '../../types';
import { safeExternalUrl } from '../../lib/safeExternalUrl';

const ICONS: Record<string, typeof BookOpen> = {
  mock_tests: ListChecks,
  practice: Layers,
  previous_papers: FileText,
  syllabus: BookOpen,
  study_material: BookOpen,
};

export function PrepareSection({ links }: { links: OpportunityPreparationLink[] }) {
  if (links.length === 0) return null;

  return (
    <section className="wfx-opp-prepare glass-surface">
      <div className="wfx-opp-prepare-head">
        <div>
          <span className="section-kicker">WebFoxx Academy</span>
          <h2>Prepare for this opportunity</h2>
          <p className="wfx-muted">Mock tests, previous papers, syllabus, and study material — in one place.</p>
        </div>
      </div>
      <div className="wfx-opp-prepare-grid">
        {links.map((link) => {
          const Icon = ICONS[link.type] ?? BookOpen;
          const href = safeExternalUrl(link.url);
          if (!href) return null;
          return (
            <a key={link.type} href={href} className="wfx-opp-prepare-link" target="_blank" rel="noopener noreferrer">
              <Icon size={20} aria-hidden="true" />
              <span>{link.label}</span>
              <ExternalLink size={14} aria-hidden="true" />
            </a>
          );
        })}
      </div>
    </section>
  );
}
